import { PlaygroundConfig } from 'modules/Playground/types/playgroundConfig';

export const cleanEmptyFieldsInFieldMap = (fields: PlaygroundConfig['fieldValueMap']) => {
  const cleanedFields: PlaygroundConfig['fieldValueMap'] = {};
  for (const [key, value] of Object.entries(fields)) {
    if (value !== null && value !== undefined) {
      cleanedFields[key] = value;
    }
  }
  return cleanedFields;
};
